<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="
      t('common.paramDateRanges', {
        param: t('shipments.dates.requestedPickup'),
      })
    "
    class="shipment-requested-pickup-filter w-3"
    help-text="mm/dd/yyyy hh:mm"
    optional
  >
    <DateRangeFilter
      :id="inputId"
      v-model="internalValue.requestedPickupDateRange"
      :placeholder="
        t('common.paramDateRanges', {
          param: t('shipments.dates.requestedPickup'),
        })
      "
      append-to="body"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';

import { ShipmentSearchCriteria } from '@/model';

import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import DateRangeFilter from '@rygen/rygen-ui/components/search/DateRangeFilter.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: ShipmentSearchCriteria,
    default: () => new ShipmentSearchCriteria(),
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: ShipmentSearchCriteria): void;
}>();
const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<ShipmentSearchCriteria>) =>
    new ShipmentSearchCriteria(opts),
});
</script>
